import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class DocumentOtherMeta extends BaseEntityModel {
  /**
   * @var {string}
   */
  otherSubType;

  /**
   * @var {number}
   */
  parentId;

  constructor(model = {}) {
    super(model);

    this.parentId = model.parentId;
    this.otherSubType = model.otherSubType;
  }
}
